<script setup lang="ts">import { createPropsRestProxy } from '/vue-macros/reactivity-transform/helper';
const content = createPropsRestProxy(__props, ["item","root"]);

import Tooltip from "@/components/Tooltip/Tooltip.vue";
import { isPasswordProtected } from "@/services/UtilitiesService";

import { Metadata } from "@/models/Metadata";

import type { TooltipContentProps, TooltipRootProps } from "reka-ui";

withDefaults(defineProps<{ item: Metadata; root?: TooltipRootProps } & TooltipContentProps>(), {  })
</script>
<template>
  <Tooltip :content-props="content" :root-props="root">
    <template #trigger>
      <slot :disabled="root?.disabled" />
    </template>
    <template #content>
      Filename: {{ item.displayName }}<br />
      Document Class: {{ item.aiClassification }}<br />
      EDX filename: {{ item.edxFilename }}<br />
      <template v-if="(item.edxCreatedOn || '').length > 0"> Uploaded on: {{ item.edxCreatedOn }} </template>
      <br v-if="(item.edxCreatedOn || '').length > 0" />
      {{ String(item.isDraft).toLowerCase() === "true" ? "Is draft: Yes" : "" }}
      <br v-if="String(item.isDraft).toLowerCase() === 'true'" />
      {{ String(item.isDuplicate).toLowerCase() === "true" ? "Is duplicate: Yes" : "" }}
      <br v-if="String(item.isDuplicate).toLowerCase() === 'true'" />

      <template
        v-if="
          item.edxProcessingStatus &&
          item.edxProcessingStatus === 'issue' &&
          item.ingestProcessingError &&
          item.ingestProcessingStatus
        "
      >
        EDX processing status: {{ item.ingestProcessingStatus }}
      </template>
      <br
        v-if="
          item.edxProcessingStatus &&
          item.edxProcessingStatus === 'issue' &&
          item.ingestProcessingError &&
          item.ingestProcessingStatus
        "
      />
      <p v-if="/justUploaded|readyToView|issue/i.test(item.edxProcessingStatus ?? ('' as never))">
        {{
          item.edxProcessingStatus === "justUploaded"
            ? "Record may be available for viewing, but has not yet been processed for search or other functionality."
            : ""
        }}
        {{
          item.edxProcessingStatus === "readyToView"
            ? "Ready for viewing, although the record has still to go through automated analysis."
            : ""
        }}
        {{
          item.edxProcessingStatus === "issue"
            ? "An error occurred during processing. Please report to your Technical Support team for investigation."
            : ""
        }}
      </p>
      <p v-if="isPasswordProtected(item)">The record is password protected</p>
      <p v-if="item.edxSummariserStatus">Summariser status: {{ item.edxSummariserStatus }}</p>
    </template>
  </Tooltip>
</template>
